const _ = require('lodash');
const { thenWithErrorHandling } = require('../../helpers/errorHandler');

module.exports = {
    /**
     * Загрузить файл
     * @param {Object} args
     * @param {Object} args.file
     * @param {Number} args.documentTypeId
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    uploadDocument ({ file, documentTypeId }, state, output, { locator, context }) {
        const API = locator.resolve('api');
        const orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        const formData = new FormData();

        formData.append(`DocumentType${documentTypeId}File`, file);

        const request = API.uploadFile(context, locator, { orderId, documentTypeId, formData });

        request.then((data) => {
            const errors = _.get(data, 'errors');

            if (errors > 0) {
                output.error({ error: errors });
                return;
            }

            output.success({ uploadedDocuments: _.get(data, 'uploadedDocuments') });
        }).fail(function (xhr, status, error) {
            output.errorTooBigFile(error);
        });
    },

    /**
     * Загрузить файл результата
     * @param {Object} args
     * @param {Object} args.file
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    uploadResultDocument ({ file }, state, output, { locator, context }) {
        const API = locator.resolve('api');
        const orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        const formData = new FormData();

        formData.append('DocumentResultFile', file);

        const request = API.uploadResultFile(context, locator, { orderId, formData });

        request.then((data) => {
            const errors = _.get(data, 'errors');

            if (errors > 0) {
                output.error({ error: errors });
                return;
            }

            output.success({ uploadedDocuments: _.get(data, 'uploadedDocuments') });
        }).fail(function (xhr, status, error) {
            output.errorTooBigFile(error);
        });
    },

    /**
     * Загружаем на WebAPI все файлы, которые были прикриплены локально
     * @param {Object} args
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    applyLocalChangesUploadDocs (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let documents = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']);

        let requests = [];
        _.forEach(documents, function(doc) {
            let formData = new FormData();
            formData.append(`DocumentType${doc.documentTypeId}File`, doc.file, doc.name);
            let request = API.uploadFile(context, locator, { orderId, documentTypeId: doc.documentTypeId, formData }).fail(function (xhr, status, error) {
                output.errorTooBigFile(error);
                return;
            });
            requests.push(request);
        });

        Promise.all(requests).then(values => {
            let errors = _.map(values, x => x.errors);
            if (_.some(errors, x => x > 0)) {
                output.error();
                return;
            }
            output.success({ uploadedDocuments: _.map(values, x => x.uploadedDocuments[0])});
        }).catch((error) => output.error({ error }));
    },

    /**
     * Обновить список документов в state
     * @param {Object} uploadedDocuments
     * @param {Object} state
     */
    updateDocumentsInState ({ uploadedDocuments }, state) {
        let documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
        _.forEach(uploadedDocuments, (uploaded) => {
            let documentIndex = _.findIndex(documents, { typeId: uploaded.typeId });
            state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id'], uploaded.id);
            state.set(
                ['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name'],
                uploaded.name
            );
        });
    },

    uploadDocumentLocal ({ documentTypeId, file }, state) {
        const documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
        let newId = '1';

        if (documents) {
            const existingDocs = _.filter(documents, 'id');

            if (existingDocs.length > 0) {
                newId = _.max(_.map(existingDocs, (x) => x.id)) + 1;
            }
        }

        // запоминаем локальное изменение
        let docs = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']);

        if (!docs) {
            docs = [];
        }

        docs = _.concat(docs, { documentTypeId, id: newId, name: file.name, file: file.slice(0, file.size, file.type) });
        state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload'], docs);

        // обновляем отображение, делаем вид, что файл загружен на сервер
        const documentIndex = _.findIndex(documents, { typeId: documentTypeId });
        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id'], newId);
        state.set(
            ['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name'],
            file.name
        );
    },

    /**
     * Добавить тип обязательного документа для заказа
     * @param {Number} documentTypeId
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    addDocumentType ({ path, value }, state, output, { locator, context }) {
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let documentTypeId = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(path),
            'typeId']);
        let API = locator.resolve('api');
        let request = API.addDocumentType(context, locator, { orderId, documentTypeId });

        thenWithErrorHandling(request, () => ({ documentTypeId: documentTypeId, isChecked: value }), output);
    },

    addDocumentTypeLocal ({ path, value }, state, output, { locator, context }) {
        let documentTypeId = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(path),
            'typeId']);

        let docs = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove']);
        if (!docs) {
            docs = [];
        }
        let indexLocal = _.findIndex(docs, { documentTypeId: documentTypeId });
        if (indexLocal > -1) {
            state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove',
                indexLocal, 'value'], value);
        } else {
            // запоминием, что этот тип надо удалить или добавить
            docs = _.concat(docs, { documentTypeId, value });
            state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove'], docs);
        }

        // обновляем отображение, делаем вид, что этот тип документа добавлен/удалён
        let index = _.findIndex(state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']),
            { 'typeId': documentTypeId });
        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', index, 'isChecked'], value);
    },

    /**
     * Обновляем список необходимых докумунтов заказа через WebAPI, применяем локальные изменения
     * @param args
     * @param state
     * @param output
     * @param locator
     * @param context
     */
    applyLocalChangesAddOrRemoveDocTypes (args, state, output, { locator, context }) {
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let documents = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'addOrRemove']);

        let requests = [];
        let API = locator.resolve('api');
        _.forEach(documents, function(doc) {
            if (doc.value === true) {
                requests.push(API.addDocumentType(context, locator, { orderId, documentTypeId: doc.documentTypeId }));
            } else {
                requests.push(API.removeDocumentType(context, locator, { orderId, documentTypeId: doc.documentTypeId }));
            }
        });
        Promise.all(requests).then(values => {
            let statuses = _.map(values, x => x.status.code);
            if (_.some(statuses, x => x !== 200)) {
                output.error({ error: statuses });
                return;
            }
            output.success();
        }).catch((error) => output.error({ error }));
    },

    /**
     * Удалить тип обязательного документа для заказа
     * @param {Number} documentTypeId
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     */
    removeDocumentType ({ path, value }, state, output, { locator, context }) {
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let documentTypeId = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments', Number(path),
            'typeId']);
        let API = locator.resolve('api');
        let request = API.removeDocumentType(context, locator, { orderId, documentTypeId });

        thenWithErrorHandling(request, () => ({ documentTypeId: documentTypeId, isChecked: false }), output);
    },

    isCheckboxChecked ({ value }, state, output) {
        if (value === true) {
            output.yes();
        } else if (value === false) {
            output.no();
        }
    },

    /**
     * Удалить приложенный документ заказа
     * @param {Number} documentId
     * @param {Object} state
     * @param {Object} output
     * @param {Object} locator
     * @param {Object} context
     * @constructor
     */
    deleteDocument ({ documentId }, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let request = API.deleteDocument(context, locator, { documentId });

        thenWithErrorHandling(request, () => ({ documentId }), output);
    },

    /**
     * Удаляем через WebAPI документы, которые удалили локально
     * @param args
     * @param state
     * @param output
     * @param locator
     * @param context
     */
    applyLocalChangesDeleteDocs (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let orderId = state.get(['account', 'orders', 'currentOrder', 'id']);
        let documents = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete']);

        let requests = [];
        _.forEach(documents, function(documentId) {
            requests.push(API.deleteDocument(context, locator, { documentId }));
        });

        Promise.all(requests).then(values => {
            let statuses = _.map(values, x => x.status.code);
            if (_.some(statuses, x => x !== 200)) {
                output.error({ error: statuses });
                return;
            }
            output.success();
        }).catch((error) => output.error({ error }));
    },

    deleteDocumentLocal ({ documentId }, state) {
        let documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
        let documentIndex = _.findIndex(documents, { id: documentId });
        state.unset(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id']);
        state.unset(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name']);

        let localUpload = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload']);
        let localUploadIndex = _.findIndex(localUpload, { id: documentId });
        // если файл был добавлен локально, то отменяем добавление
        if (localUploadIndex > -1) {
            state.unset(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'upload', localUploadIndex]);
        // иначе запоминаем удаление
        } else {
            let docs = state.get(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete']);
            if (!docs) {
                docs = [];
            }
            docs = _.concat(docs, documentId);
            state.set(['account', 'orders', 'currentOrder', 'localChanges', 'necessaryDocuments', 'delete'], docs);
        }
    },

    /**
     * Удалить документ из state
     * @param {Number} documentId
     * @param {Object} state
     */
    deleteDocumentFromState ({ documentId }, state) {
        let documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
        let documentIndex = _.findIndex(documents, { id: documentId });
        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'id'], null);
        state.set(['account', 'orders', 'currentOrder', 'necessaryDocuments', documentIndex, 'name'], null);
    }
};



// WEBPACK FOOTER //
// ./actions/account/documents.js